export const canMoveBilling = (user) =>
  (user?.roles || []).some((role) => ['ROLE_ADMIN', 'ROLE_INTERNAL'].includes(role));
